import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TWServiceProfileLayout = function TWServiceProfileLayout(_ref) {
  var children = _ref.children,
      headerSlot = _ref.headerSlot,
      sidebarSlot = _ref.sidebarSlot,
      classes = _ref.classes;
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full ".concat(classes),
    children: [sidebarSlot && /*#__PURE__*/_jsx("aside", {
      className: "md:hidden",
      children: sidebarSlot
    }), headerSlot && /*#__PURE__*/_jsx("header", {
      className: "border border-t-0 border-r-0 border-l-0 bg-white border-neutral-200 shadow-mob",
      children: /*#__PURE__*/_jsx("div", {
        className: "max-w-full lg:max-w-screen-xl lg:mx-auto md:px-4",
        children: headerSlot
      })
    }), /*#__PURE__*/_jsx("main", {
      className: "max-w-full lg:max-w-screen-xl lg:mx-auto md:px-4",
      children: children
    })]
  });
};